import { supabase } from '@/integrations/supabase/client';

/** As rotas da instalação no backend (`routes/tt-fixa.routes.ts`). */
export async function chamarInstalacao<T>(path: string, metodo: 'GET' | 'POST' = 'POST', body?: unknown): Promise<T> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('Sua sessão expirou. Entre novamente.');
  const base = ((import.meta.env.VITE_SUPABASE_URL as string) || 'https://beta.crm-api.primetecia.com.br/api').replace(/\/$/, '');
  const r = await fetch(`${base}/v1/instalacao/${path}`, {
    method: metodo,
    headers: { Authorization: `Bearer ${session.access_token}`, ...(metodo === 'POST' ? { 'Content-Type': 'application/json' } : {}) },
    ...(metodo === 'POST' ? { body: JSON.stringify(body ?? {}) } : {}),
  });
  const corpo = await r.json().catch(() => ({ error: 'O CRM não respondeu corretamente.' }));
  if (!r.ok) throw new Error(corpo.error || 'Não foi possível concluir.');
  return corpo.data as T;
}
